module.exports = __webpack_public_path__ + "static/img/2.cd5edd1a.png";